import Vue from 'vue';
import Vuex from 'vuex';
//import { getInstance } from "@/auth";

Vue.use(Vuex)

const state = {
    token: "authToken"
}

const mutations = {
    changeTitle(state, token) {
        state.token = token
    },
    /*updateAccessToken: (state, accessToken) => {
      state.accessToken = accessToken;
    }*/
}

export default new Vuex.Store({
    state : state,
    mutations : mutations
})
